import { PaymentConfirmation } from "@/modules/payment-confirmation/views/payment-confirmation-view";
import { SinglePageCheckoutView } from "@/modules/single-page-checkout/views/single-page-checkout-view";
import { useCheckoutSessionV3 } from "@/modules/checkout-session/api-hooks/use-checkout-session";
import { type CheckoutSession, CheckoutStatus } from "@/types";
import * as mobile from "@/lib/mobile";

interface ConfirmationPageProps {
  onCheckoutFetched: (session: CheckoutSession) => void;
}

export function ConfirmationPage(props: ConfirmationPageProps) {
  const { data: session } = useCheckoutSessionV3();

  const handleSessionFetched = (fetchedSession: CheckoutSession) => {
    if (fetchedSession.status === CheckoutStatus.SUCCEEDED) {
      mobile.sendMessage(
        fetchedSession.order.id,
        "instore_checkout_success",
        "view_order_details",
      );
    }

    props.onCheckoutFetched(fetchedSession);
  };

  if (session?.isOfferPreSelected) {
    return <SinglePageCheckoutView onSessionFetched={handleSessionFetched} />;
  }

  return (
    <PaymentConfirmation
      onBack={() => {}} // Navigation is now handled directly in PaymentConfirmation component
      onSessionFetched={handleSessionFetched}
    />
  );
}
